<template>
  <div class="match-brief-card">
    <div class="match-header">
      <div class="teams-section">
        <div>
          <div>Players</div>
          <div>{{ selectedPlayersCount }}/11</div>
        </div>
        <div class="teams-section-center">
          <div class="team-item team-a">
            <Dimg width="20px" height="20px" :src="matchInfo.teamALogo || ''" :alt="matchInfo.teamAShort"
              class="team-logo" />
            <span class="team-name">{{ matchInfo.teamAShort }}</span>
          </div>
          <div class="match-center">
            <span class="match-time">{{ matchInfo.teamAPlayerCount || 0 }} : {{ matchInfo.teamBPlayerCount || 0
              }}</span>
            <span class="match-status" :class="statusClass">{{ statusText }}</span>
          </div>
          <div class="team-item team-b">
            <Dimg width="20px" height="20px" :src="matchInfo.teamBLogo || ''" :alt="matchInfo.teamBShort"
              class="team-logo" />
            <span class="team-name">{{ matchInfo.teamBShort }}</span>
          </div>
        </div>
        <div>
          <div>Credits left</div>
          <div>{{ 100 - usedCredits }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Dimg from '@/components/Dimg/index.vue'
import { MatchStatus } from '@/views/contests/matchesType.js'

const props = defineProps({
  matchInfo: {
    type: Object,
    required: true,
    default: () => ({
      teamAShort: '',
      teamBShort: '',
      teamALogo: '',
      teamBLogo: '',
      timestampStart: 0,
      status: 0,
      teamAPlayerCount: 0,
      teamBPlayerCount: 0,
    }),
  },
  selectedPlayersCount: {
    type: Number,
    default: 0,
  },
  usedCredits: {
    type: Number,
    default: 0,
  },
})

const statusText = computed(() => {
  const status = props.matchInfo.status
  if (status === MatchStatus.LIVE) return 'LIVE'
  if (status === MatchStatus.COMPLETED) return 'Completed'
  return 'Upcoming'
})

const statusClass = computed(() => {
  const status = props.matchInfo.status
  return {
    'status-live': status === MatchStatus.LIVE,
    'status-completed': status === MatchStatus.COMPLETED,
    'status-upcoming': status === MatchStatus.NOT_STARTED,
  }
})
</script>

<style lang="less" scoped>
.match-brief-card {
  border-radius: 12px;
  padding: 10px 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  color: #FFFFFF;

  .teams-section-center {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .match-header {
    .teams-section {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .team-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;

        .team-name {
          font-size: 14px;
          font-weight: 600;
        }
      }

      .match-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;

        .match-time {
          font-size: 20px;
          color: #FFFFFF;
        }

        .match-status {
          font-size: 11px;
          font-weight: 500;
          padding: 2px 8px;
          border-radius: 10px;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>
